/* eslint-disable max-len */
export const TOP_CNT = {
  title: "Content Creator Verification",
  text: "Thank you for your interest in wanting to become a RedGIFs Verified Content Creator. Becoming a Verified Content Creator on RedGIFs means your profile will stand out and attract more attention. As well as this you will be able to add links to sites where users can find more of your content. To become verified please complete the following steps:"
};

export const VERIFY_STEPS = [
  {
    title: "Provide your links",
    index: 1,
    text: "Please provide at least 2 links to the accounts you would like to display on your profile.",
    list: [
      "At least 1 of the links given needs to be from the following sites: OnlyFans, ManyVids, Chaturbate, MyFreeCams, Pornhub or Fansly.",
      "There is no limit on number of links a user can provide. Feel free to add as many as you would like to see displayed."
    ]
  },
  {
    title: "Upload photo",
    index: 2,
    text: "Please ensure the photo uploaded fulfils the following requirements:",
    list: [
      "SFW photo of you holding a sign with your RedGIFs profile URL written on it, which is:",
      "Photo must be compatible with the identity that can be seen on links provided.",
      "No digitally modified images.",
      "File types supported: JPG, PNG."
    ]
  },
  {
    title: "Hit Verify Account button",
    index: 3,
    text: "You will then receive email notification to confirm your account verification."
  }
];

const TWITTER = "twitter";
const PORNHUB = "pornhub";
const INSTAGRAM = "instagram";
const MANYVIDS = "manyvids";
const REDDIT = "reddit";
const ONLYFANS = "onlyfans";
const PATREON = "patreon";
const XHAMSTER = "xhamster";
const CHATURBATE = "chaturbate";
const MYFREECAMS = "myfreecams";
const FANSLY = "fansly";
const CAMSODA = "camsoda";
const FANCENTRO = "fancentro";

export const LINK_REGEXP = {
  [TWITTER]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}([a-z]+\.)?twitter\.com/i,
    isRequired: false,
    socialKey: "socialUrl2"
  },
  [PORNHUB]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}([a-z]+\.)?pornhub\.com/i,
    isRequired: true,
    socialKey: "socialUrl1"
  },
  [INSTAGRAM]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}instagram\.com/i,
    isRequired: false,
    socialKey: "socialUrl3"
  },
  [MANYVIDS]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}([a-zA-Z0-9_]+\.)?(manyvids\.com)/i,
    isRequired: true,
    socialKey: "socialUrl4"
  },
  [REDDIT]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}(new\.)?reddit\.com/i,
    isRequired: false,
    socialKey: "socialUrl5"
  },
  [ONLYFANS]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}onlyfans\.com/i,
    isRequired: true,
    socialKey: "socialUrl6"
  },
  [PATREON]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}patreon\.com/i,
    isRequired: false,
    socialKey: "socialUrl7"
  },
  [XHAMSTER]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}([a-z]+\.)?(xhamster(4|live)?\.com)/i,
    isRequired: false,
    socialKey: "socialUrl8"
  },
  [CHATURBATE]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}(m\.)?([a-z]+\.)?chaturbate\.com/i,
    isRequired: true,
    socialKey: "socialUrl9"
  },
  [MYFREECAMS]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}(profiles\.|share\.){0,1}myfreecams\.com/i,
    isRequired: true,
    socialKey: "socialUrl10"
  },
  [FANSLY]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}(fans\.ly|fansly\.com)/i,
    isRequired: true,
    socialKey: "socialUrl11"
  },
  [CAMSODA]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}camsoda\.com/i,
    isRequired: false,
    socialKey: "socialUrl12"
  },
  [FANCENTRO]: {
    regExp: /^(http[s]?:\/\/){0,1}(www\.){0,1}fancentro\.com/i,
    isRequired: false,
    socialKey: "socialUrl13"
  },
};
